import {app} from '../main'
import * as types from './mutation-types'
import { router } from '../router'
import { api } from './http-common'
const objectToFormData = require('object-to-formdata')
let apiClient = {
  loadItems () {
    return new Promise((resolve, reject) => {
      const LS = JSON.parse(localStorage.itemsSG || '{}')
      resolve({ ...LS })
    })
  },
  updateItems (data) {
    localStorage.itemsSG = JSON.stringify(data)
  }
}

export const state = {
  lang: 'ru',
  seriesNumber: '',
  trackingNumber: '',
  product: {},
  changeLogo: false,
  LS: undefined,
  warrantyAnswer: null,
  warrantyNumber: '',
  warrantyData: {},
  warrantyLoading: false,
  serviceAnswer: {
    reason: {
      title: '',
      description: ''
    },
    delivery: {
      receiver_first_name: '',
      receiver_last_name: '',
      receiver_middle_name: '',
      receiver_phone: '',
      city: {
        code: '',
        title: ''
      },
      warenhouse: {
        code: '',
        title: ''
      }
    },
    contact: {
      first_name: '',
      last_name: '',
      email: '',
      phone: ''
    },
    status: [
      {
        code: '',
        title: '',
        active: false,
        subtitle: ''
      }
    ],
    can_edit_delivery_address: false,
    can_close: false,
    closed: false,
    guarantee_date: '',
    is_guarantee: false
  },
  videoCall: {}
}

export const getters = {
  getLS: state => {
    return state.LS
  },
  getVideoCall: state => {
    return state.videoCall
  },
  getCurrentLang: state => {
    return state.lang
  },
  getProduct: state => {
    return state.product
  },
  getRequestAnswer: state => {
    return state.serviceAnswer
  },
  getChangeLogo: state => {
    return state.changeLogo
  },
  getSeriesNumber: state => {
    return state.seriesNumber
  },
  getWarrantyNumber: state => {
    return state.warrantyNumber
  },
  getTrackingNumber: state => {
    return state.trackingNumber
  },
  getWarrantyAnswer: state => {
    return state.warrantyAnswer
  },
  getWarrantyData: state => {
    return state.warrantyData
  },
  getWarrantyLoading: state => {
    return state.warrantyLoading
  }
}

export const mutations = {
  [types.SET_LANG] (state, payload) {
    app.$i18n.locale = payload
    state.lang = payload
  },
  setVideoCall (state, payload) {
    state.videoCall = payload
  },
  setProduct (state, payload) {
    state.product = payload
  },
  setRequestAnswer (state, payload) {
    state.serviceAnswer = payload
  },
  setWarrantyAnswer (state, payload) {
    state.warrantyAnswer = payload
  },
  changeLogo (state, payload) {
    state.changeLogo = payload
  },
  setFields (state, { seriesNumber, trackingNumber }) {
    state.seriesNumber = seriesNumber
    state.trackingNumber = trackingNumber
  },
  setLS (state, payload) {
    state.LS = payload
  },
  updateServiceNumber (state, payload) {
    state.seriesNumber = payload
  },
  updateWarrantyNumber (state, payload) {
    state.warrantyNumber = payload
  },
  setTrackingNumber (state, payload) {
    state.trackingNumber = payload
  },
  setWarrantyData (state, payload) {
    state.warrantyData = payload
  },
  setWarrantyLoading (state, payload) {
    state.warrantyLoading = payload
  }
}

export const actions = {
  setLang ({commit}, payload) {
    commit(types.SET_LANG, payload)
  },
  async setLangNew ({commit}, payload) {
    if (payload in app.$i18n.messages) {
      commit(types.SET_LANG, payload)
    } else {
      try {
        // const res = await axios.get(`./src/lang/${payload}.json`)
        // const res = await axios.get(`http://localhost:8080/lang/${payload}.json`)
        const res = await import(`../../src/lang/${payload}.json`)
        app.$i18n.setLocaleMessage(payload, res.data)
        commit(types.SET_LANG, payload)
      } catch (e) {
        console.log(e)
      }
    }
  },
  // check if seriesNumber correct
  seriesNumber ({commit, state}, payload) {
    let data = new FormData()
    data.append('imei', payload)

    return api
      .post('ajax.php?action=sg:service.api.repairrequest.checkImei', data)
      .then(response => {
        if (response.data.data === true) {
          // if change or new seriesNumber update lS
          let { seriesNumber } = state.LS
          if (seriesNumber !== payload) {
            state.LS.seriesNumber = payload
            apiClient.updateItems(state.LS)
          }
          router.push({ path: `/product`, query: {sn: payload} })
        }
        return response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  // post trackingNumber
  trackingNumber ({commit}, payload) {
    let data = new FormData()
    data.append('code', payload)
    return api
      .post('ajax.php?action=sg:service.api.repairrequest.checkTrackingCode', data)
      .then(response => {
        if (response.data.data) {
          // if change or new trackingNumber update lS
          let { trackingNumber } = state.LS
          if (trackingNumber !== payload) {
            state.LS.trackingNumber = payload
            apiClient.updateItems(state.LS)
          }
          router.push({ path: `/tracking`, query: {tn: payload} })
        }
        return response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  // get warranty info
  warrantyNumber ({commit}, payload) {
    let data = new FormData()
    data.append('imei', payload)
    return api
      .post('ajax.php?action=sg:service.api.repairrequest.checkImei', data)
      .then(response => {
        if (response.data.data) {
          let {warrantyNumber} = state.LS
          if (warrantyNumber !== payload) {
            state.LS.warrantyNumber = payload
            apiClient.updateItems(state.LS)
          }
          router.push({path: `/warranty`, query: {sn: payload}})
        }
      })
  },
  loadWarrantyData ({commit, state}, sn) {
    commit('setWarrantyLoading', true)
    let data = new FormData()
    data.append('imei', sn)
    api
      .post('ajax.php?action=sg:service.api.product.getInfo', data)
      .then(response => {
        if (response.data.status === 'success') {
          commit('setWarrantyData', response.data.data)
        }
        commit('setWarrantyLoading', false)
      }).catch(() => {
        commit('setWarrantyLoading', false)
      })
  },
  // get product info
  getProduct ({commit, state}, sn) {
    let data = new FormData()
    data.append('imei', sn)
    api
      .post('ajax.php?action=sg:service.api.product.getInfo', data)
      .then(response => {
        if (response.data.status !== 'success' || !response.data.data) {
          router.push({path: '/'})
        }
        commit('setProduct', response.data.data)
      })
  },
  // Request chat
  requestChat ({commit, state}, payload) {
    return new Promise((resolve, reject) => {
      api
        .post('/chat', [state.fields.email, payload])
        .then(response => {
          if (response.data.status === 'OK') {
            // if change or new email update lS
            let { email } = state.LS
            if (email !== state.fields.email) {
              state.LS.email = state.fields.email
              apiClient.updateItems(state.LS)
            }
          }
          resolve(response)
        }, error => {
          reject(error)
        })
    })
  },
  // TrackingData
  getTrackingData ({commit, state}, tn) {
    let data = new FormData()
    data.append('code', tn)
    return api
      .post('ajax.php?action=sg:service.api.repairrequest.getInfo', data)
      .then(response => {
        if (response.data.status === 'error') {
          router.push({path: '/'})
        }
        commit('updateServiceNumber', response.data.data.product_imei)
        commit('setRequestAnswer', response.data.data)
        // if change or new seriesNumber update lS
        let { seriesNumber } = state.LS
        if (seriesNumber !== response.data.data.product_imei) {
          state.LS.seriesNumber = response.data.data.product_imei
          apiClient.updateItems(state.LS)
        }
        return response.data
      })
  },
  repairRequestAccept ({commit, state, dispatch}) {
    let data = new FormData()
    data.append('code', state.LS.trackingNumber)
    api
      .post('ajax.php?action=sg:service.api.repairrequest.accept', data)
      .then(response => {
        if (response.data.status === 'success') {
          dispatch('getTrackingData')
        }
      })
  },
  repairRequestCancel ({commit, state, dispatch}) {
    let data = new FormData()
    data.append('code', state.LS.trackingNumber)
    api
      .post('ajax.php?action=sg:service.api.repairrequest.close', data)
      .then(response => {
        if (response.data.status === 'success') {
          router.push({name: 'cancelSuccess', params: {messages: response.data.data.delivery}})
        }
      })
  },
  // Get address Delivery
  getAddressDelivery ({commit, state}) {
    return new Promise((resolve, reject) => {
      apiClient.loadItems().then((dataLS) => {
        commit('setLS', dataLS)
        commit('setFields', dataLS)
      }).then(() => {
        api
          .post('/getAdressDelivery', state.fields.trackingNumber)
          .then(response => {
            if (response.data.status === 'OK') {
              commit('updateAddressDeliveryStreet', response.data.address.street)
              commit('updateAddressDeliveryHome', response.data.address.home)
              commit('updateAddressDeliveryRoom', response.data.address.room)
            }
            resolve(response)
          }, error => {
            reject(error)
          })
      })
    })
  },
  changeWhereToGet ({commit, state}) {
    api
      .post('/changeWhereToGet', state.serviceRequest.whereToGet, state.trackingNumber)
      .then(response => {
        router.go(-1)
      })
  },
  changeLogo ({commit}, payload) {
    commit('changeLogo', payload)
  },
  // get data from LS and set tu stateLS and someFields
  getLS ({commit, state}) {
    return new Promise((resolve, reject) => {
      apiClient.loadItems().then((dataLS) => {
        commit('setLS', dataLS)
        commit('setFields', dataLS)
        resolve(dataLS)
      })
    })
  },
  videoChange ({commit, state}, payload) {
    payload.code = state.videoCall.code
    let data = objectToFormData(payload)
    api
      .post('ajax.php?action=sg:service.api.videocall.change', data)
      .then(response => {
        if (response.data.status === 'success') {
          payload.code = state.videoCall.code
          commit('setVideoCall', payload)
          router.push({ path: '/video-success' })
        }
      })
  },
  updateTrackingNumber ({commit, state}, payload) {
    commit('setTrackingNumber', payload)
    let { trackingNumber } = state.LS
    if (trackingNumber !== payload) {
      state.LS.trackingNumber = payload
      apiClient.updateItems(state.LS)
    }
    router.push({path: '/requestSuccess'})
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js